import { render, staticRenderFns } from "./customerPrompt.vue?vue&type=template&id=2fecfa2c&scoped=true&"
import script from "./customerPrompt.vue?vue&type=script&lang=js&"
export * from "./customerPrompt.vue?vue&type=script&lang=js&"
import style0 from "./customerPrompt.vue?vue&type=style&index=0&id=2fecfa2c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fecfa2c",
  null
  
)

export default component.exports